module.exports = __webpack_public_path__ + "static/media/Image_not_available.41d461b6.svg";